import { Button } from "@/components/ui/button";
import { Save, Mail, CheckCircle } from "lucide-react";
import { BTN } from "@/components/common/btn";
import { WOCompleteButton } from "./WOCompleteButton";

// Action buttons shown when the WO is in `draft` status. For brand-new
// WOs (no editingWO yet) just shows Save; for existing drafts shows
// the full Save / Work Order / Approve / Complete row.
// Colours follow the kit rule: write = green, mailto composer = slate.
export function WODraftActions({
  editingWO,
  handleSave, openEmailDialog,
  confirmWOComplete, setConfirmWOComplete,
}) {
  if (!editingWO) {
    return (
      <Button size="sm" className={BTN.write} onClick={() => handleSave()} title="Save" data-testid="btn-save-wo">
        <Save className="w-3.5 h-3.5 mr-1" /> Save work order
      </Button>
    );
  }
  return (
    <>
      <Button size="sm" className={BTN.write} onClick={() => handleSave()} title="Save" data-testid="btn-save-wo">
        <Save className="w-3.5 h-3.5" />
      </Button>
      <Button size="sm" className={BTN.internal} onClick={() => openEmailDialog("submit")} data-testid="btn-email-wo">
        <Mail className="w-3.5 h-3.5 mr-1" /> WO
      </Button>
      <Button size="sm" className={BTN.write} onClick={() => handleSave("approved")} data-testid="btn-approve-wo">
        <CheckCircle className="w-3.5 h-3.5 mr-1" /> Approve
      </Button>
      <WOCompleteButton
        confirmWOComplete={confirmWOComplete}
        setConfirmWOComplete={setConfirmWOComplete}
        onConfirm={() => handleSave("completed")}
      />
    </>
  );
}
